import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    UsuarioID: localStorage.getItem("UsuarioID") || null,
    access_token: localStorage.getItem("access_token") || null,
  }),

  actions: {
    async login(formData, router) {
      try {
        const response = await fetch("https://api.fletes-mexico.com/login", {
          method: "POST",
          body: formData,
        });
        if (!response.ok) {
          throw new Error("Error en el login");
        } else {
          const data = await response.json();

          //consulta la informacion del usuario
          const apiInfoUser = "https://api.fletes-mexico.com/users/me";
          const responseUser = await fetch(apiInfoUser, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${data.access_token}`,
            },
          });
          const dataUser = await responseUser.json();

          this.UsuarioID = dataUser.UsuarioID;
          this.access_token = data.access_token;

          localStorage.setItem("access_token", data.access_token);
          localStorage.setItem("UsuarioID", dataUser.UsuarioID);
        }

        router.push("/");
      } catch (error) {
        console.error("Error en la autenticación:", error);
        throw error;
      }
    },

    logout(router) {
      this.UsuarioID = null;
      this.access_token = null;

      localStorage.removeItem("access_token");
      localStorage.removeItem("UsuarioID");

      router.push("/login");
    },
  },
});
